import React from "react";
import { useFormContext } from "react-hook-form";
import { MapPin } from "lucide-react";

const PINCODE_PATTERN = /^\d{6}$/;

const PincodeGateSection = ({ serviceablePincodeSet }) => {
    const { register, setValue, watch, formState: { errors } } = useFormContext();
    const pincode = watch("pincode") || "";
    const isServiceable = PINCODE_PATTERN.test(pincode) && serviceablePincodeSet.has(pincode);

    return (
        <div className="hvt-quick-section">
            <div className="hvt-quick-section-title"><MapPin size={13} /> Service Area Check</div>
            <div className="hvt-field">
                <label className="required">Pincode</label>
                <input
                    type="text"
                    className="form-control"
                    maxLength={6}
                    placeholder="Enter 6-digit pincode"
                    {...register("pincode", {
                        required: "Required",
                        pattern: { value: PINCODE_PATTERN, message: "Enter a valid 6-digit pincode" },
                        validate: (v) => serviceablePincodeSet.has(v) || "Home-visit service isn't available at this pincode",
                        onChange: (e) => setValue("pincode", e.target.value.replace(/\D/g, ""), { shouldValidate: true }),
                    })}
                />
                {errors.pincode && <small className="text-danger">{errors.pincode.message}</small>}
                {!errors.pincode && isServiceable && <small className="text-success">Serviceable — you can proceed.</small>}
            </div>
        </div>
    );
};

export default PincodeGateSection;
